import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../reminder_question_respond';

export default function Launcher(props) {
  const config = useDialogConfig();

  const question = useConnect('question.byId', {
    id: config.params.questionId
  });

  if (question.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <Dialog
      question={question}
      onClose={props.onClose}
    />
  );
};
